<template>
  <div class="w-full px-3 flex items-center justify-between">
    <label :for="checkboxId" class="ml-2 text-gray-dark">{{ selectedExamplesCount }} selected</label>
    <div class="flex">
      <base-button variant="hover:transparent-error"
                   class="flex items-center text-gray-dark hover:text-focus-error"
                   id="delete-button"
                   @click="updateMode(EXAMPLE_EDITOR_MODE.BULK_DELETE)"
      >
        <delete-icon/>
      </base-button>

      <base-button variant="transparent"
                   class="flex items-center text-gray-dark"
                   id="move-button"
                   @click="updateMode(EXAMPLE_EDITOR_MODE.BULK_MOVE)"
      >
        <move-icon/>
        <span class="my-auto ml-2">Move</span>
      </base-button>
    </div>
  </div>
</template>

<script>
import { EXAMPLE_EDITOR_MODE } from '@/store/constants'
import DeleteIcon from '@/assets/images/icons/DeleteIcon'
import MoveIcon from '@/assets/images/icons/MoveIcon'

export default {
  name: 'IntentExamplesHeaderBulk',
  components: { DeleteIcon, MoveIcon },
  props: {
    checkboxId: {
      type: String
    },
    selectedExamplesCount: {
      type: Number
    }
  },
  data() {
    return {
      EXAMPLE_EDITOR_MODE
    }
  },
  methods: {
    updateMode(mode) {
      this.$emit('update-mode', mode)
    }
  }
}
</script>
